import React from "react";

const NotFound = () => {
  return (
    <div>
      <span className="text-lg text-center">404 Not Found</span>
    </div>
  );
};
export default NotFound;
